import { render, staticRenderFns } from "./promoTion.vue?vue&type=template&id=f7f5b7ae&scoped=true&"
import script from "./promoTion.vue?vue&type=script&lang=js&"
export * from "./promoTion.vue?vue&type=script&lang=js&"
import style0 from "./promoTion.vue?vue&type=style&index=0&id=f7f5b7ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f5b7ae",
  null
  
)

export default component.exports